module.exports = "/_next/static/images/dbea6bd726772627a658e9b93874012d-product-information-xs-1x.jpg.webp";